export { LoginGuard } from "app/guards/login.guard";
export { AdminProfileGuard } from "app/guards/admin-profile.guard";
export { SocioProfileGuard } from "./socio-profile.guard";


// WEBPACK FOOTER //
// ./src/app/guards/guards.index.ts